// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_ServiceOrders_GetInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /customer-portal/v1/service-orders/get
 *
 * `document` follows the same any-form-then-normalize rule as
 * Portal_ServiceOrders_ListInput — see its docblock. `order_id` needs no
 * extra validation here: any id that does not resolve to an order owned by
 * the (normalized) document collapses to the same 404 `order_not_found` the
 * controller returns for a genuinely nonexistent id — no oracle either way.
 */
import { registerContract } from './validate'

export interface Portal_ServiceOrders_GetInput {
document: string
order_id: number
}

registerContract('Portal_ServiceOrders_GetInput', {
  document: { type: 'string',  required: true },
  order_id: { type: 'number',  required: true },
})
